import * as React from 'preact/compat'

import { loadStylesheet } from '#js/common/helpers'

import SvelteWrapper from '#components/SvelteWrapper'

import Comment from './SearchItemComment_svelte.svelte'

const SvelteComment = SvelteWrapper(Comment)

export default class SearchItemComment extends React.Component<any, any> {

  componentWillMount() {
    loadStylesheet('comments')
  }

  render() {
    return <SvelteComment item={this.props.item}/>
  }
}
